import React from "react";
import { Clock } from "lucide-react";
import type { ClientePedidoStatusRow } from "../utils/mapPainelParaColunasCliente";
import {
  TV_RETIRADA_MINUTOS_DEMORADO,
  minutosDesdeProntoParaRetirada,
} from "../utils/splitProntosRetiradaTv";
import { formatTvHoraIso } from "../utils/formatTvHora";

interface FaixaPedidosDemorandoRetiradaProps {
  itens: ClientePedidoStatusRow[];
  agora: Date;
  dateLabel: string;
}

/** Faixa inferior discreta com rolagem horizontal dos pedidos há muito tempo no balcão. */
export const FaixaPedidosDemorandoRetirada: React.FC<
  FaixaPedidosDemorandoRetiradaProps
> = ({ itens, agora, dateLabel }) => (
  <footer
    className="sticky bottom-0 z-20 mt-4 border-t border-white/10 bg-black/30 py-1.5 backdrop-blur-sm sm:mt-5 sm:py-2"
    role="region"
    aria-label={`Pedidos prontos há mais de ${TV_RETIRADA_MINUTOS_DEMORADO} minutos hoje`}
  >
    <div className="mb-1.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-0.5 px-3 text-[10px] text-white/45 sm:mb-2 sm:px-4 sm:text-[11px]">
      <span className="inline-flex items-center gap-1.5">
        <Clock
          className="h-3 w-3 shrink-0 opacity-70"
          strokeWidth={2}
          aria-hidden
        />
        <span>Pedidos já prontos e/ou retirados hoje· {dateLabel}</span>
      </span>
    </div>

    <div className="relative overflow-hidden">
      {itens.length === 0 ? (
        <p className="px-3 py-0.5 text-center text-[10px] text-white/30 sm:text-[11px]">
          Nenhum pedido pronto há mais de {TV_RETIRADA_MINUTOS_DEMORADO} minutos
        </p>
      ) : (
        <div className="flex w-max animate-tv-retirada-marquee py-0.5">
          {[0, 1].map((dup) =>
            itens.map((row) => {
              const min = minutosDesdeProntoParaRetirada(
                row.prontoParaRetiradaEm,
                agora
              );
              const minutosLabel =
                min != null
                  ? `${min} min`
                  : `${TV_RETIRADA_MINUTOS_DEMORADO}+ min`;
              return (
                <div
                  key={`${dup}-${row.displayId}`}
                  className="mr-3 flex shrink-0 items-center rounded-md border border-white/10 bg-white/[0.06] px-2.5 py-1 sm:mr-4 sm:px-3"
                >
                  <span className="whitespace-nowrap text-[10px] font-medium text-white/70 sm:text-xs">
                    <span className="text-white/85">{row.customerName}</span>
                    <span className="text-white/40"> · </span>#{row.displayId}
                    <span className="text-white/40"> · </span>
                    {formatTvHoraIso(row.prontoParaRetiradaEm)}
                    <span className="text-white/40"> · </span>
                    {minutosLabel}
                  </span>
                </div>
              );
            })
          )}
        </div>
      )}
    </div>
  </footer>
);
